import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
} from "recharts";

const MoneyInMonthlyChart = ({ statementData, loading }) => {
  if (loading) {
    return (
      <div className="w-full h-[450px] flex items-center justify-center bg-white rounded-[20px]">
        <span className="text-gray-500 text-lg">Loading chart data...</span>
      </div>
    );
  }

  const monthlyData = statementData?.data?.monthly || [];

  // Map data safely
  const data = monthlyData?.map((item) => ({
    month: item?.MONTH,
    inflow: Number(item["TOTAL INFLOWS"] || 0),
  }));

  // Check if all inflows are zero
  const allZero = data?.every((d) => d.inflow === 0);
  if (!data?.length || allZero) {
    return (
      <div className="w-full h-[450px] flex items-center justify-center bg-white rounded-[20px]">
        <span className="text-gray-500 text-lg">
          No monthly inflow data available
        </span>
      </div>
    );
  }

  const maxValue = Math?.max(...data.map((d) => d?.inflow)) * 1.1;
  const avgInflow =
    data.reduce((sum, d) => sum + d?.inflow, 0) / (data?.length || 1);

  return (
    <ResponsiveContainer width="100%" height={450}>
      <BarChart
        data={data}
        margin={{ top: 30, right: 30, left: 40, bottom: 70 }}
      >
        <CartesianGrid strokeDasharray="3 3" />

        <XAxis
          dataKey="month"
          angle={-30}
          textAnchor="end"
          interval={0}
          height={70}
        />

        <YAxis
          domain={[0, maxValue]}
          tickFormatter={(value) =>
            (value / 1000)?.toLocaleString("en-US") + "K"
          }
          allowDecimals={false}
        />

        <Tooltip
          formatter={(value) =>
            Number(value)?.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          }
        />

        <ReferenceLine
          y={avgInflow}
          label={{
            value: "Average",
            position: "insideTopRight",
            fill: "#FF0000",
            fontSize: 12,
          }}
          stroke="#FF0000"
          strokeDasharray="3 3"
        />

        <Bar dataKey="inflow" fill="#2f446f" barSize={45} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MoneyInMonthlyChart;
